import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';

import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import {StudentPapersSection} from './publications'


// Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

const StudentSection = ({sectionTitle, sectionRef, students}) => {

    const cards = students.map((studentInfo, studentIndex) => {
        let website = "";

        if ('website' in studentInfo) {
            website = (
                    <>
                        <br/>
                        <b><a href={studentInfo.website}>Personal Website</a></b>
                    </>
                );
        }

        return (
            <Card className="mt-3 mb-3">
                <Card.Header as="h5">{studentInfo.name}</Card.Header>
                <Card.Body>
                    <Row>
                        <Col xs={2} md={4} lg={4} className="pr-0">
                            <Image src={studentInfo.photo} rounded fluid />
                        </Col>

                        <Col xs={10} md={8} lg={8}>
                            <div dangerouslySetInnerHTML={{__html : studentInfo.blurb}} />
                            {website}
                            <StudentPapersSection studentName={studentInfo.name}></StudentPapersSection>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            );
        }
    );

    return (
        <>
        <Jumbotron className="p-3 mb-0 mt-3" ref={sectionRef}>
            <h2 className="phd-jumbo">{sectionTitle}</h2>
        </Jumbotron>
        {cards}
    </>
    );
}


const D2S2Lab = () => {
    let [selectedNav, setSelectedNav] = useState("Doctoral");

    const doctoralRef = useRef(null);
    const mastersRef = useRef(null);
    const ugraRef = useRef(null);
    const graduatedRef = useRef(null);

    const updateSelectedNav = (newSelect: string):void => {
        console.log("new nav selection is: '" + newSelect + "'");
        setSelectedNav(newSelect);

        if (newSelect === "Doctoral") {
            doctoralRef.current.scrollIntoView();
        } else if (newSelect === "Masters") {
            mastersRef.current.scrollIntoView();
        } else if (newSelect === "Undergraduates") {
            ugraRef.current.scrollIntoView();
        } else if (newSelect === "Graduated") {
            graduatedRef.current.scrollIntoView();
        }
    }


    const phdStudents = [
        {
            name : "Zimeng Lyu",
            photo : "./assets/img/zimeng.jpg",
            blurb : "My name is Zimeng Lyu, I am a PhD student at Rochester Institute of Technology. I am interested in NeuroEvolution Neural Architecture Search and Time Series Forecasting in Machine Learning.",
            website : "https://zimenglyu.com/"
        },
        {
            name : "Josh Karns",
            photo : "",
            blurb : ""
        },
        {
            name : "Hong Yang",
            photo : "./assets/img/hong.jpg",
            blurb : "Hi! My name is Hong Yang and I am a PhD student at RIT. I am working with Travis Desell on the NGAFID project. My research interest includes times series analysis, transformers, deep learning, and regularization. When I am not studying, I am playing with my dog Rosie."
        }
    ];

    const mastersStudents = [
        {
            name : "Jared Murphy",
            photo : "./assets/img/jared.jpg",
            blurb : "Hi! My name is Jared Murphy. I have a background in Statistics and I am now in my first year of the Data Science masters program at RIT. My current research interests are Bayesian Hyperparameter Optimization and Bayesian RNN's."
        },
        {
            name : "Ruben McWilliams",
            photo : "./assets/img/ruben.jpg",
            blurb : "Hello! My name is Ruben McWilliams, I am in my first year of the MS Data Science program. I am currently doing research pertaining to Self Organizing Maps."
        }
    ];


    const ugraStudents = [
        {
            name : "Aaron Chan",
            photo : "./assets/img/aaron_chan.jpg",
            blurb : "Hi! My name is Aaron Chan and I am an undergraduate Software Engineering student at RIT from New York City. My main research interests include Applied Machine Learning, Data Science, Computer Vision and Robotics. My main focus for the lab currently is the NGAFID project. In my free time, I engineer rockets and electric vehicles, as well as enjoy running, weightlifting and rock climbing."
        }
    ];

    const graduatedStudents = [
        {
            name : "AbdElRahman ElSaid",
            photo : "./assets/img/aelsaid.jpg",
            blurb : "Dr. AbdElRahman ElSaid graduated the D2S2 Lab in 2020 and has since joined the faculty in the <a href='https://www.uprm.edu/cse/faculty/'>Computer Science and Engineering department at the Universidad de Puerto Rico - Recinto de Mayagüez (RUM)</a>. His current research interests are in nature inspired neural architecture search methods”."
        },
        {
            name : "Farhad Akhbardeh",
            photo : "./assets/img/farhad.jpg",
            blurb : "Hello! My name is Farhad Akhbardeh and I’m a Ph.D. student at Rochester Institute of Technology. My research interests are Natural Language Processing and Machine Learning. I am also working with Dr. Travis Desell on the National General Aviation Flight Information Database (NGAFID) project."
        },
        {
            name : "Hitesh Ulhas Vaidya",
            photo : "./assets/img/hitesh.jpg",
            blurb : "Hi! My name is Hitesh Ulhas Vaidya. I am interested in biologically inspired machine learning in general. I enjoy learning about human sleep and memory formation in human brain. I am excited to use these ideas in Artificial Intelligence. When I am not studying, I enjoy music, movies, traveling, swimming and badminton.",
            website : "https://people.rit.edu/hv8322/"
        },
        {
            name : "Dan Castellarin",
            photo : "./assets/img/dan.jpg",
            blurb : "Hello! My name is Dan Castellarin, and I'm an undergraduate Computer Science student at Rochester Institute of Technology. I recently joined the team working on the NGAFID project. Some topics I'm interested in are Artificial Intelligence, and High Performance Computing, and Robotics. Outside of academics, I enjoy watching movies and TV, playing intramural ice hockey, and watching sports."
        },
        {
            name : "Aidan LaBella",
            photo : "./assets/img/aidan.jpg",
            blurb : "Aidan graduated the D2S2 Lab in May 2023 with a BSc in Computer Science. He is now pursuing his Ph.D. in Computer Science at Brown University in Providence, RI where he is advised by <a href='https://cs.brown.edu/people/sbach'>Stephen Bach</a> in the BATS research group and AI 'superlab'. His interests revolve around making sense of large real-world datasets using machine learning and data science techniques.",
            website : "https://cs.brown.edu/people/grad/alabella/"
        },
    ];


    return (
        <>
            <Nav className="justify-content-center" activeKey={selectedNav} onSelect={(selectedKey) => updateSelectedNav(selectedKey)}>
                <Nav.Item>
                    <Nav.Link eventKey="Doctoral">Doctoral</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="Masters">Masters</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="Undergraduates">Undergraduates</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="Alumni">Graduated</Nav.Link>
                </Nav.Item>
            </Nav>

            <StudentSection sectionTitle="Doctoral Research Assistants" sectionRef={doctoralRef} students={phdStudents}></StudentSection>
            <StudentSection sectionTitle="Masters Research Assistants" sectionRef={mastersRef} students={mastersStudents}></StudentSection>
            <StudentSection sectionTitle="Undergraduate Research Assistants" sectionRef={ugraRef} students={ugraStudents}></StudentSection>
            <StudentSection sectionTitle="Graduates" sectionRef={graduatedRef} students={graduatedStudents}></StudentSection>
        </>
    );
};


export default D2S2Lab;
